import { render, staticRenderFns } from "./CRUDTableMaritalStatus.vue?vue&type=template&id=6d7cbad1"
import script from "./CRUDTableMaritalStatus.vue?vue&type=script&lang=js"
export * from "./CRUDTableMaritalStatus.vue?vue&type=script&lang=js"
import style0 from "./CRUDTableMaritalStatus.vue?vue&type=style&index=0&id=6d7cbad1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports